import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as Skeleton } from './Skeleton.vue';
export interface SkeletonProps {
	class?: HTMLAttributes['class'];
	variant?: SkeletonVariants['variant'];
	isActive?: boolean;
	onlySkeleton?: boolean;
}

export const skeletonVariants = cva('animate-pulse rounded-md', {
	variants: {
		variant: {
			primary: 'bg-primary-light-4',
			'primary-light-1': 'bg-primary-light-1',
			black: 'bg-black',
			white: 'bg-white-dark-2',
			whiteHighlight: 'bg-white'
		}
	},
	defaultVariants: {
		variant: 'primary'
	}
});

export type SkeletonVariants = VariantProps<typeof skeletonVariants>;
